// ============================================================
// VCS.DatingCore — REST-Calls fuer den Dating-Teil
// ============================================================
// Pendant zu dating_service.dart in der Flutter-App. Konzept und Regeln:
// dating_plan.md (Flutter-Projekt), PWA-Umsetzung: dating_pwa_plan.md.
//
// Kein Aufruf hier kennt eine Telefonnummer — im Dating-Teil laeuft alles
// ueber den serverseitig vergebenen Handle. Deshalb auch kein authHeaders()
// aus chat-core: das faellt ohne Token still auf x-phone zurueck, und die
// Nummer ist hier nie Identitaet. Ohne Token laeuft gar nichts erst los.
// ============================================================
window.VCS = window.VCS || {};

VCS.DatingCore = class {

    // ── Konstanten ───────────────────────────────────────────
    // Spiegeln die Server-Whitelists (routes.js: DATING_GENDERS/SEEKING/
    // MODES/INTENTS). Weichen sie ab, antwortet der Server mit invalid_*.

    static MAX_PHOTOS = 3;
    static GENDERS  = ['f', 'm', 'other'];
    static SEEKING  = ['f', 'm', 'any'];
    static MODES    = ['local', 'remote', 'both'];
    static INTENTS  = ['talk', 'relationship', 'sex'];

    // Melde-Gruende. Feste Liste, kein Freitext -- der waere ein Kanal, ueber den Fremde
    // einander beschimpfen, und muesste auch noch uebersetzt werden. Muss zu
    // DATING_REPORT_REASONS (routes.js) passen, sonst macht der Server "other" draus.
    static REPORT_REASONS = ['fake', 'offensive', 'nudity', 'minor', 'spam', 'other'];

    // Grenzen der gesuchten Altersspanne. Untergrenze 18 ist keine Kosmetik:
    // Niemand soll nach Minderjaehrigen suchen koennen, auch nicht ins Leere.
    // Der Server prueft dasselbe und antwortet sonst mit invalid_age_range.
    static AGE_MIN = 18;
    static AGE_MAX = 99;

    // Gesuchter Umkreis in km. Gilt NUR bei mode = 'local': Wer 'both' waehlt, dem
    // ist der Ort egal ("dann werden alle verfuegbaren Founds angezeigt", User
    // 17.07.), und 'remote' fragt nach dem Land.
    //
    // RADIUS_ANY ist das obere Ende und heisst "egal", nicht "500 km genau": Dort
    // filtert der Server gar nicht erst. Sonst muesste jemand, dem die Entfernung
    // gleich ist, bei 499 haltmachen.
    //
    // Muss zu DATING_RADIUS_MIN/MAX in routes.js passen. Der Kartenstapel suchte
    // bis 17.07. in der 3x3-Zellnachbarschaft des Radars (~3,7 km) — das war nie
    // eine Entscheidung, sondern ein Erbe: Stapel und Radar teilten sich ein Query.
    static RADIUS_MIN = 1;
    static RADIUS_ANY = 500;

    // Wie genau sich jemand zeigt, entscheidet er selbst (16.07.). Nur diese zwei
    // Stufen — ein Regler mit sieben Zwischenwerten waere eine Frage, die niemand
    // beantworten kann. Muss zu DATING_PRECISIONS in routes.js passen.
    //   6 = ungefaehr, ~750 x 610 m ("ist in der Gegend") — Voreinstellung
    //   8 = genau,     ~38 x 19 m   ("da steht er")
    // Der Server kuerzt die Zelle ohnehin auf den Wert im Profil: Die Einstellung
    // ist ein Riegel, keine Bitte.
    static PRECISION_ROUGH = 6;
    static PRECISION_EXACT = 8;
    static PRECISIONS = [6, 8];

    // Laender fuer den Fern-Modus. Endonyme (Eigennamen), damit die Namen NICHT
    // durch die 16 Sprachdateien geschleift werden muessen: Ein Land heisst in
    // seiner eigenen Sprache immer gleich, egal welche Oberflaeche eingestellt
    // ist. Auswahl = die Laender zu den Sprachen aus AVAILABLE_LANGS, plus
    // AT/CH/BR/US, weil Sprache != Land. Gleiche Liste wie dating_countries.dart.
    // Codes sind ISO-3166-1 alpha-2 (der Server prueft nur auf Laenge 2).
    static COUNTRIES = {
        DE: 'Deutschland',
        AT: 'Österreich',
        CH: 'Schweiz',
        RU: 'Россия',
        UA: 'Україна',
        GB: 'United Kingdom',
        US: 'United States',
        FR: 'France',
        ES: 'España',
        IT: 'Italia',
        PT: 'Portugal',
        BR: 'Brasil',
        NL: 'Nederland',
        PL: 'Polska',
        CZ: 'Česko',
        HU: 'Magyarország',
        TR: 'Türkiye',
        CN: '中国',
        JP: '日本',
        VN: 'Việt Nam',
        XX: 'Anderes Land'
    };

    // Interessen (2026-07-18): rudimentaere, feste Auswahl. Muss zu DATING_INTERESTS in
    // routes.js passen. Das Emoji ist sprachuebergreifend erkennbar, das Label kommt aus
    // den Sprachdateien (datingInterest_<key>). Kein Freitext -- bewusst schlank.
    static INTERESTS = [
        { key: 'travel',      emoji: '✈️' },
        { key: 'sport',       emoji: '⚽' },
        { key: 'fitness',     emoji: '💪' },
        { key: 'music',       emoji: '🎵' },
        { key: 'cooking',     emoji: '🍳' },
        { key: 'movies',      emoji: '🎬' },
        { key: 'reading',     emoji: '📚' },
        { key: 'gaming',      emoji: '🎮' },
        { key: 'nature',      emoji: '🥾' },
        { key: 'art',         emoji: '🎨' },
        { key: 'photography', emoji: '📷' },
        { key: 'dancing',     emoji: '💃' },
        { key: 'animals',     emoji: '🐾' },
        { key: 'food',        emoji: '🍽️' },
        { key: 'party',       emoji: '🎉' }
    ];
    static INTERESTS_MAX = 10;

    // Rauchen/Alkohol: '' = keine Angabe, sonst eine dieser Stufen. Nur Anzeige, kein
    // Suchfilter. Muss zu DATING_HABITS in routes.js passen.
    static HABITS = ['no', 'sometimes', 'yes'];

    // Koerpergroesse in cm. 0 = keine Angabe. Muss zu DATING_HEIGHT_MIN/MAX passen.
    static HEIGHT_MIN = 120;
    static HEIGHT_MAX = 250;

    // Sternzeichen aus Monat (1-12) und Tag. Gibt { key, emoji } oder null (keine Angabe).
    // Grenzen sind die ueblichen Datumsbereiche; in beiden Clients gleich berechnet, damit
    // niemand ein abweichendes Zeichen sieht. Das Zeichen wird NICHT gespeichert.
    static zodiac(month, day) {
        const m = parseInt(month, 10);
        const d = parseInt(day, 10);
        if (!(m >= 1 && m <= 12) || !(d >= 1 && d <= 31)) {
            return null;
        }
        // "until" = letzter Tag im Kalenderjahr, an dem dieses Zeichen noch gilt.
        const signs = [
            { key: 'capricorn',   emoji: '♑', until: [1, 19] },
            { key: 'aquarius',    emoji: '♒', until: [2, 18] },
            { key: 'pisces',      emoji: '♓', until: [3, 20] },
            { key: 'aries',       emoji: '♈', until: [4, 19] },
            { key: 'taurus',      emoji: '♉', until: [5, 20] },
            { key: 'gemini',      emoji: '♊', until: [6, 20] },
            { key: 'cancer',      emoji: '♋', until: [7, 22] },
            { key: 'leo',         emoji: '♌', until: [8, 22] },
            { key: 'virgo',       emoji: '♍', until: [9, 22] },
            { key: 'libra',       emoji: '♎', until: [10, 22] },
            { key: 'scorpio',     emoji: '♏', until: [11, 21] },
            { key: 'sagittarius', emoji: '♐', until: [12, 21] },
            { key: 'capricorn',   emoji: '♑', until: [12, 31] }
        ];
        for (const s of signs) {
            if (m < s.until[0] || (m === s.until[0] && d <= s.until[1])) {
                return { key: s.key, emoji: s.emoji };
            }
        }
        return { key: 'capricorn', emoji: '♑' };
    }

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        // Zuletzt geladenes eigenes Profil. null = noch nicht geladen oder keins
        // angelegt. Die Landing zeigt danach, ob es schon ein Profil gibt.
        this.profile = null;
    }

    init() {}

    // ── Auth ─────────────────────────────────────────────────

    // Nur Bearer, nie x-phone. Gibt null zurueck, wenn kein Token da ist —
    // der Aufrufer bricht dann ab, statt einen Request zu schicken, den der
    // Server ohnehin mit 401 beantwortet.
    _headers(extra = {}) {
        const token = VCS.state.chatAuthToken;
        if (!token) {
            return null;
        }
        return { ...extra, 'Authorization': 'Bearer ' + token };
    }

    _jsonHeaders() {
        return this._headers({ 'Content-Type': 'application/json' });
    }

    _url(path) {
        return VCS.Chat.API_BASE + path;
    }

    // ── Profil ───────────────────────────────────────────────

    // Eigenes Profil. null = noch keins angelegt (204) oder Fehler.
    async getProfile() {
        const headers = this._headers();
        if (!headers) {
            console.warn('[dating] getProfile: kein Token');
            return null;
        }
        try {
            const res = await fetch(this._url('/dating/profile'), { headers });
            // 204 = noch kein Profil angelegt (existierende Route, leerer Zustand). Kein
            // 404 mehr -- das wuerde die Server-Flood-/Fail2Ban-Erkennung ausloesen und den
            // Nutzer aussperren. 404 bleibt als Fallback fuer aeltere Server-Versionen.
            if (res.status === 204 || res.status === 404) {
                console.log('[dating] getProfile: noch kein Profil (status=' + res.status + ')');
                this.profile = null;
                return null;
            }
            if (!res.ok) {
                console.warn('[dating] getProfile fehlgeschlagen: status=' + res.status);
                return null;
            }
            this.profile = await res.json();
            console.log('[dating] getProfile OK: handle=' + this.profile.handle
                + ' active=' + this.profile.active + ' mode=' + this.profile.mode);
            return this.profile;
        } catch (e) {
            console.warn('[dating] getProfile Fehler:', e && e.message ? e.message : e);
            return null;
        }
    }

    // Anlegen oder aendern. Beim ersten Mal vergibt der Server den Handle.
    // Fehlercodes kommen durch (invalid_bio, invalid_age, ...), damit die UI
    // sie uebersetzen kann.
    async saveProfile(data) {
        const headers = this._jsonHeaders();
        if (!headers) {
            return { ok: false, error: 'unauthorized' };
        }
        const payload = {
            displayName: data.displayName || '',
            bio        : data.bio || '',
            birthYear  : data.birthYear || 0,
            gender     : data.gender || '',
            seeking    : data.seeking || '',
            // Altersspanne und Standort-Genauigkeit gehen immer mit. Fehlende
            // Felder laesst der Server zwar stehen (statt sie auf Default zu
            // setzen) -- das ist die Ruecksicht auf aeltere Clients, kein Grund,
            // sie wegzulassen: Das Formular kennt beide Werte, also sagt es sie.
            seekAgeMin   : data.seekAgeMin || VCS.DatingCore.AGE_MIN,
            seekAgeMax   : data.seekAgeMax || VCS.DatingCore.AGE_MAX,
            seekRadiusKm : data.seekRadiusKm || VCS.DatingCore.RADIUS_ANY,
            cellPrecision: data.cellPrecision || VCS.DatingCore.PRECISION_ROUGH,
            mode       : data.mode || 'local',
            langs      : data.langs || [],
            intents    : data.intents || [],
            // Zusatzfelder (2026-07-18). birthMonth/birthDay nur fuers Sternzeichen; das
            // Jahr steckt in birthYear. Immer mitschicken -- das Formular kennt die Werte.
            birthMonth : data.birthMonth || 0,
            birthDay   : data.birthDay || 0,
            heightCm   : data.heightCm || 0,
            smoking    : data.smoking || '',
            drinking   : data.drinking || '',
            interests  : data.interests || []
        };
        if (data.country) {
            payload.country = data.country;
        }
        try {
            const res = await fetch(this._url('/dating/profile'), {
                method : 'POST',
                headers: headers,
                body   : JSON.stringify(payload)
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) {
                console.warn('[dating] saveProfile abgelehnt: status=' + res.status
                    + ' error=' + (body.error || 'unknown'));
                return { ok: false, error: body.error || 'unknown' };
            }
            this.profile = body;
            console.log('[dating] saveProfile OK: handle=' + body.handle + ' mode=' + body.mode);
            return { ok: true, profile: body };
        } catch (e) {
            console.warn('[dating] saveProfile Fehler:', e && e.message ? e.message : e);
            return { ok: false, error: 'network' };
        }
    }

    // Dating-Teil loeschen. Der Messenger-Account bleibt. Der Handle ist danach
    // weg, ein neues Profil bekommt einen neuen.
    async deleteProfile() {
        const headers = this._headers();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/profile'), { method: 'DELETE', headers });
            if (res.ok) {
                this.profile = null;
                console.log('[dating] deleteProfile OK');
            } else {
                console.warn('[dating] deleteProfile fehlgeschlagen: status=' + res.status);
            }
            return res.ok;
        } catch (e) {
            console.warn('[dating] deleteProfile Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }

    // ── Sichtbarkeit ─────────────────────────────────────────

    // Ein/aus. Beim Ausschalten loescht der Server auch die Geo-Zelle — es
    // bleibt kein Standort liegen, wenn niemand sucht.
    async setActive(active) {
        const headers = this._jsonHeaders();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/active'), {
                method : 'POST',
                headers: headers,
                body   : JSON.stringify({ active: active === true })
            });
            if (res.ok && this.profile) {
                this.profile.active = active === true;
            }
            console.log('[dating] setActive ' + (active ? 'an' : 'aus') + ': status=' + res.status);
            return res.ok;
        } catch (e) {
            console.warn('[dating] setActive Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }

    // ── Geo-Zelle ────────────────────────────────────────────

    // Nur die gerundete Zelle, nie die Position. Gerundet wird auf dem Geraet
    // (dating-geo.js), bevor irgendetwas den Browser verlaesst.
    async setCell(cell) {
        const headers = this._jsonHeaders();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/cell'), {
                method : 'POST',
                headers: headers,
                body   : JSON.stringify({ cell: cell })
            });
            console.log('[dating] setCell: status=' + res.status);
            return res.ok;
        } catch (e) {
            console.warn('[dating] setCell Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }

    // Standort auf dem Server vergessen — beim Abschalten und bei verweigerter
    // Ortungsfreigabe. Es soll nichts liegenbleiben.
    async clearCell() {
        const headers = this._headers();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/cell'), { method: 'DELETE', headers });
            console.log('[dating] clearCell: status=' + res.status);
            return res.ok;
        } catch (e) {
            console.warn('[dating] clearCell Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }

    // ── Deck / Swipe / Matches ───────────────────────────────

    // Kandidaten. remote=true → Fern-Modus (Land/Sprache) statt Nah (Geo-Zelle).
    // Fehlercodes: no_cell, no_intent, mode_mismatch, no_profile.
    //
    // fresh=true fragt "wer ist JETZT hier" (Praesenz-Fenster von 60 s auf dem
    // Server) — das will nur das Radar. Der Stapel fragt "wer ist in der Gegend"
    // und waere mit Fenster fast immer leer: zwei Fragen, zwei Ansichten.
    // likesMe=true fragt /dating/likes statt /dating/deck — den Stapel derer, die mich schon
    // geliked haben. Gleiche Antwortform; ein Rechts-Wisch matcht dort sofort. remote/fresh
    // gelten dann nicht.
    async getDeck(remote = false, fresh = false, likesMe = false) {
        const headers = this._headers();
        if (!headers) {
            return { ok: false, error: 'unauthorized', deck: [] };
        }
        try {
            const url = likesMe
                ? this._url('/dating/likes')
                : this._url('/dating/deck?mode=' + (remote ? 'remote' : 'local')
                    + (fresh ? '&fresh=1' : ''));
            const res = await fetch(url, { headers });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) {
                // 409 = erwarteter Business-Zustand (no_profile, no_intent, mode_mismatch,
                // no_cell), kein Serverfehler -> nicht als WARN loggen. Die UI zeigt den
                // Grund ohnehin ueber errorInfo(). Nur Unerwartetes (5xx, Netz) warnen.
                if (res.status !== 409) {
                    console.warn('[dating] getDeck abgelehnt: status=' + res.status
                        + ' error=' + (body.error || 'unknown'));
                }
                return { ok: false, error: body.error || 'unknown', deck: [] };
            }
            const deck = body.deck || [];
            console.log('[dating] getDeck OK: '
                + (likesMe ? 'likes' : 'mode=' + (remote ? 'remote' : 'local') + (fresh ? ' fresh=1' : ''))
                + ' kandidaten=' + deck.length);
            return { ok: true, deck: deck };
        } catch (e) {
            console.warn('[dating] getDeck Fehler:', e && e.message ? e.message : e);
            return { ok: false, error: 'network', deck: [] };
        }
    }

    // Nur die Zahl fuer die Landing-Kachel „Mögen dich (x)". Leicht: ein COUNT, keine
    // Profile. 0 bei Fehler — dann bleibt die Kachel eben ohne Zahl.
    async getLikesCount() {
        const headers = this._headers();
        if (!headers) {
            return 0;
        }
        try {
            const res = await fetch(this._url('/dating/likes/count'), { headers });
            if (!res.ok) {
                return 0;
            }
            const body = await res.json().catch(() => ({}));
            return body.count || 0;
        } catch (e) {
            console.warn('[dating] getLikesCount Fehler:', e && e.message ? e.message : e);
            return 0;
        }
    }

    // Entscheidung speichern. true = daraus wurde ein Match (der andere hatte
    // mich schon geliked).
    async swipe(handle, like) {
        const headers = this._jsonHeaders();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/swipe'), {
                method : 'POST',
                headers: headers,
                body   : JSON.stringify({ handle: handle, like: like === true })
            });
            if (!res.ok) {
                // 409 = erwarteter Business-Zustand (no_profile, not_found), kein Fehler.
                if (res.status !== 409) console.warn('[dating] swipe fehlgeschlagen: status=' + res.status);
                return false;
            }
            const body = await res.json().catch(() => ({}));
            console.log('[dating] swipe ' + (like ? 'like' : 'nope') + ': match=' + (body.match === true));
            return body.match === true;
        } catch (e) {
            console.warn('[dating] swipe Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }

    // Jemanden blockieren (blocked=true) oder entblocken (false). Wirkt serverseitig
    // BEIDSEITIG: der andere verschwindet fuer mich und ich fuer ihn. true = Erfolg.
    // Pendant zu dating_service.block().
    async block(handle, blocked = true) {
        const headers = this._jsonHeaders();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/block'), {
                method : 'POST',
                headers: headers,
                body   : JSON.stringify({ handle: handle, blocked: blocked !== false })
            });
            if (!res.ok) {
                // 409 = erwarteter Business-Zustand (no_profile, not_found), kein Fehler.
                if (res.status !== 409) console.warn('[dating] block fehlgeschlagen: status=' + res.status);
                return false;
            }
            console.log('[dating] block ' + (blocked !== false ? 'an' : 'aus') + ': ' + String(handle).slice(0, 8));
            return true;
        } catch (e) {
            console.warn('[dating] block Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }

    // Profil melden. reason aus REPORT_REASONS (sonst macht der Server "other" draus). Der
    // Server legt den Block gleich mit an -- ein Aufruf, keine Race. Pendant zu
    // dating_service.report(). true = Erfolg.
    async report(handle, reason) {
        const headers = this._jsonHeaders();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/report'), {
                method : 'POST',
                headers: headers,
                body   : JSON.stringify({ handle: handle, reason: reason })
            });
            if (!res.ok) {
                if (res.status !== 409) console.warn('[dating] report fehlgeschlagen: status=' + res.status);
                return false;
            }
            console.log('[dating] report "' + reason + '": ' + String(handle).slice(0, 8));
            return true;
        } catch (e) {
            console.warn('[dating] report Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }

    // Match aufloesen (kein Block/Report). Der Server entfernt den daraus entstandenen
    // Kontakt und nimmt den Chat aus der Liste -- die Nachrichten bleiben. true = Erfolg.
    async unmatch(handle) {
        const headers = this._jsonHeaders();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/unmatch'), {
                method : 'POST',
                headers: headers,
                body   : JSON.stringify({ handle: handle })
            });
            if (!res.ok) {
                if (res.status !== 409) console.warn('[dating] unmatch fehlgeschlagen: status=' + res.status);
                return false;
            }
            console.log('[dating] unmatch: ' + String(handle).slice(0, 8));
            return true;
        } catch (e) {
            console.warn('[dating] unmatch Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }

    async getMatches() {
        const headers = this._headers();
        if (!headers) {
            return [];
        }
        try {
            const res = await fetch(this._url('/dating/matches'), { headers });
            if (!res.ok) {
                // 409 = kein Profil/Leerzustand (erwartet), kein Fehler -> nicht warnen.
                if (res.status !== 409) console.warn('[dating] getMatches fehlgeschlagen: status=' + res.status);
                return [];
            }
            const body = await res.json().catch(() => ({}));
            const matches = body.matches || [];
            console.log('[dating] getMatches OK: anzahl=' + matches.length);
            return matches;
        } catch (e) {
            console.warn('[dating] getMatches Fehler:', e && e.message ? e.message : e);
            return [];
        }
    }

    // ── Fotos ────────────────────────────────────────────────

    // Hashes der eigenen Fotos, in Reihenfolge.
    async getPhotos() {
        const headers = this._headers();
        if (!headers) {
            return [];
        }
        try {
            const res = await fetch(this._url('/dating/photos'), { headers });
            if (!res.ok) {
                // 409 = kein Profil (erwartet), kein Fehler -> nicht warnen.
                if (res.status !== 409) console.warn('[dating] getPhotos fehlgeschlagen: status=' + res.status);
                return [];
            }
            const body = await res.json().catch(() => ({}));
            return body.photos || [];
        } catch (e) {
            console.warn('[dating] getPhotos Fehler:', e && e.message ? e.message : e);
            return [];
        }
    }

    // Reihenfolge setzen — `hashes` IST die Reihenfolge. Zurueck kommt die Liste, wie
    // sie jetzt in der DB steht (massgeblich), oder null bei einem Fehler.
    //
    // Es gehen immer ALLE Hashes hin, nicht „schiebe das eine nach vorn": Der Server
    // nummeriert die ganze Liste neu, damit zwei Geraete die Sortierung nicht
    // gegeneinander verstellen koennen.
    async setPhotoOrder(hashes) {
        const headers = this._headers();
        if (!headers) {
            return null;
        }
        try {
            const res = await fetch(this._url('/dating/photos/order'), {
                method : 'POST',
                headers: Object.assign({ 'Content-Type': 'application/json' }, headers),
                body   : JSON.stringify({ order: hashes })
            });
            if (!res.ok) {
                // 409 = kein Profil (erwartet), kein Fehler -> nicht warnen.
                if (res.status !== 409) console.warn('[dating] setPhotoOrder fehlgeschlagen: status=' + res.status);
                return null;
            }
            const body = await res.json().catch(() => ({}));
            return body.photos || null;
        } catch (e) {
            console.warn('[dating] setPhotoOrder Fehler:', e && e.message ? e.message : e);
            return null;
        }
    }

    // Dating-Fotos gehen nur an eingeloggte Nutzer — anders als der Avatar ist
    // /dating/photo/:hash nicht oeffentlich. Ein blankes <img src> bekaeme 401,
    // deshalb erst laden, dann als Blob-URL anzeigen. Der Aufrufer ist fuer
    // revokeObjectURL zustaendig (siehe releasePhotoUrl).
    async loadPhotoUrl(photoHash) {
        const headers = this._headers();
        if (!headers) {
            return '';
        }
        try {
            const res = await fetch(this._url('/dating/photo/' + photoHash), { headers });
            if (!res.ok) {
                console.warn('[dating] loadPhotoUrl fehlgeschlagen: hash=' + photoHash
                    + ' status=' + res.status);
                return '';
            }
            const blob = await res.blob();
            return URL.createObjectURL(blob);
        } catch (e) {
            console.warn('[dating] loadPhotoUrl Fehler:', e && e.message ? e.message : e);
            return '';
        }
    }

    // Gegenstueck zu loadPhotoUrl. Nur eigene Blob-URLs freigeben — geliehene
    // nie (memory: mediaCache-Ownership).
    releasePhotoUrl(url) {
        if (url && url.startsWith('blob:')) {
            URL.revokeObjectURL(url);
        }
    }

    // Foto hochladen. Content-Type NICHT setzen — die Boundary setzt der
    // Browser selbst.
    //
    // Gibt `{ hash, error }` zurueck statt nur den Hash: Der Server prueft Fotos seit dem
    // 17.07. auf Nacktheit und lehnt mit `photo_nudity` / `photo_illegal` ab. Bis dahin
    // verschwand dieser Grund in der Konsole, und der Nutzer las „Foto konnte nicht
    // hochgeladen werden" — das klingt nach Netzproblem und ist schlicht falsch: Es KONNTE,
    // es DURFTE nicht. (17.07., vom Gruender gemeldet: „Das Bild wird ja korrekt abgelehnt,
    // nur der Text ist falsch.")
    async uploadPhoto(file) {
        const headers = this._headers();
        if (!headers) {
            return { hash: '', error: 'auth' };
        }
        try {
            const fd = new FormData();
            fd.append('photo', file);
            const res = await fetch(this._url('/dating/photo'), {
                method : 'POST',
                headers: headers,
                body   : fd
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) {
                // 409 = kein Profil (erwartet), kein Fehler -> nicht warnen. Echte Ablehnungen
                // (photo_nudity/illegal/too_many_photos = 400) bleiben eine WARN-Zeile.
                if (res.status !== 409) {
                    console.warn('[dating] uploadPhoto abgelehnt: status=' + res.status
                        + ' error=' + (body.error || 'unknown'));
                }
                return { hash: '', error: body.error || 'unknown' };
            }
            console.log('[dating] uploadPhoto OK: hash=' + body.photoHash);
            return { hash: body.photoHash || '', error: '' };
        } catch (e) {
            console.warn('[dating] uploadPhoto Fehler:', e && e.message ? e.message : e);
            return { hash: '', error: 'network' };
        }
    }

    // Warum ein Foto nicht durchging. Eigener Text pro Fall — „konnte nicht hochgeladen
    // werden" fuer eine Ablehnung waere eine Luege, und wer nicht erfaehrt, WAS falsch war,
    // laedt dasselbe Bild gleich nochmal hoch.
    static photoErrorText(code) {
        switch (code) {
            case 'photo_nudity':    return t('datingErrPhotoNudity');
            case 'photo_illegal':   return t('datingErrPhotoIllegal');
            case 'too_many_photos': return t('datingErrTooManyPhotos');
            case 'network':         return t('datingErrNetwork');
            default:                return t('datingErrUpload');
        }
    }

    async deletePhoto(photoHash) {
        const headers = this._headers();
        if (!headers) {
            return false;
        }
        try {
            const res = await fetch(this._url('/dating/photo/' + photoHash), {
                method : 'DELETE',
                headers: headers
            });
            console.log('[dating] deletePhoto hash=' + photoHash + ': status=' + res.status);
            return res.ok;
        } catch (e) {
            console.warn('[dating] deletePhoto Fehler:', e && e.message ? e.message : e);
            return false;
        }
    }
};
